// apps/web/src/pages/pcp/remessas-acoes.tsx — Fase 17.1, Plano 26 (L-51).
// Ações de escrita do cabeçalho de Remessas (novo retorno, importar NF-e, nova remessa manual): só com
// `remessas:gerenciar`. Quem só consulta (Faturamento, Gestão, Diretor) vê a lista e um aviso curto.
// Ergonomia apenas: a autorização real é o 403 da API em cada rota de escrita.
import type { ReactElement } from 'react';
import { FileText } from 'lucide-react';

export const PERMISSAO_GERENCIAR_REMESSAS = 'remessas:gerenciar';

export const TEXTO_CONSULTA_DE_REMESSAS = 'Consulta de remessas. Criar remessa e registrar retorno ficam com o PCP.';

/** A sessão pode criar remessa, registrar retorno e importar NF-e? Fail-closed enquanto a sessão não carrega. */
export function podeGerenciarRemessas(permissoes: readonly string[] | null): boolean {
  return permissoes !== null && permissoes.includes(PERMISSAO_GERENCIAR_REMESSAS);
}

interface RemessasAcoesProps {
  /** Permissões da sessão; `null` enquanto a sessão carrega ou quando não há sessão. */
  readonly permissoes: readonly string[] | null;
  readonly onNovoRetorno: () => void;
  readonly onImportarNfe: () => void;
  readonly onNovaRemessaManual: () => void;
}

export function RemessasAcoes({ permissoes, onNovoRetorno, onImportarNfe, onNovaRemessaManual }: RemessasAcoesProps): ReactElement | null {
  if (permissoes === null) return null;
  if (!podeGerenciarRemessas(permissoes)) {
    return (
      <p data-testid="remessas-somente-consulta" className="text-sm text-slate-500">
        {TEXTO_CONSULTA_DE_REMESSAS}
      </p>
    );
  }
  return (
    <div className="flex flex-wrap gap-3">
      <button
        type="button"
        onClick={onNovoRetorno}
        className="px-4 py-2.5 border border-slate-300 bg-white text-slate-700 font-medium rounded text-sm hover:bg-slate-50 focus:ring-2 focus:ring-blue-500 focus:outline-none touch-manipulation"
      >
        Novo Retorno
      </button>
      <button
        type="button"
        onClick={onImportarNfe}
        className="px-4 py-2.5 border border-blue-600 bg-blue-50 text-blue-700 font-semibold rounded text-sm hover:bg-blue-100 focus:ring-2 focus:ring-blue-500 focus:outline-none flex items-center gap-2 touch-manipulation"
      >
        <FileText className="w-4 h-4" />
        Importar NF de remessa (XML/chave)
      </button>
      <button
        type="button"
        onClick={onNovaRemessaManual}
        className="px-4 py-2.5 bg-blue-600 text-white font-semibold rounded text-sm hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:outline-none touch-manipulation"
      >
        + Nova Remessa Manual
      </button>
    </div>
  );
}
